import { useCallback, useEffect, useState } from 'react';

export type Theme = 'dark' | 'light';
// Key bumped to invalidate any stale 'dark' that older builds persisted on every mount — LIGHT is
// the default now, and only an explicit toggle should ever store 'dark'.
const KEY = 'cc-theme2';

function current(): Theme {
  return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

/**
 * Theme state synced to <html data-theme>. LIGHT is the default (set pre-paint in index.html).
 * Toggling persists the choice to localStorage.
 */
export function useTheme(): { theme: Theme; toggle: () => void } {
  const [theme, setTheme] = useState<Theme>(current);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      /* storage blocked — in-memory only */
    }
  }, [theme]);

  const toggle = useCallback(() => setTheme((t) => (t === 'dark' ? 'light' : 'dark')), []);
  return { theme, toggle };
}
